import {RFIDAssetsRow} from "./type";
import {Link} from "react-router-dom";
import {Badge} from "../../../components/Badge";
import {ColDef} from "ag-grid-community";
import React, {useState} from "react";
import {rfidAction} from "./RfidActions";

import toast from "react-hot-toast";
import {downloadBrandedQR} from "../../tickets/components/brandedQr";
import PromoCodeSendModal from "../../../components/PromoCodeSendModal";
import {createApolloClient} from "../../../providers/ApolloClientFactory";
import {TICKET_SEND_EMAIL_SMS} from "../../tickets/ticket-search/mutations";

const client = createApolloClient();


const ButtonCellRenderer = (props: any) => {
    const {data} = props as { data: RFIDAssetsRow };
    const { uid } = data || {};
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sendType, setSendType] = useState("");

    const handleButtonClick = async () => {
        const {id} = props.data;
        console.log({id})
        await rfidAction({id});
    };
    const tokensBalance = data?.tokens_balance;
    let tokenStrings: string[];
    if (tokensBalance && Object.keys(tokensBalance).length > 0) {
        tokenStrings = Object.values<any>(tokensBalance).map(
            (token) => `${token.redeemable_token_name} - ${token.balance}`
        );
    }

    const handleDownloadClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        try {
            const accessType =
                (data as any)?.access_type || (data?.is_qr ? "QR Code" : "Asset");

            await downloadBrandedQR({
                uid: String(uid ?? ""),
                itemName: accessType,
                bottomText: `UID: ${uid}`,
                bottomText2: data.reg_id ? `Print ID: ${data?.reg_id}` : '',
                bottomText3: tokenStrings ? `Token Balance: ${tokenStrings}` : '',
                logoBase64: "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",
                qrSize: 500,
                logoSize: 100,
                fontSize: 24,
                fileName: `${String(accessType).replace(/\s+/g, "-")}-${uid}`,
            });

            toast.success("QR downloaded");
        } catch (error) {
            toast.error("Failed to download QR");
        }
    };

    const handleSendClick = (type: string) => {
        setSendType(type);
        setIsModalOpen(true);
    };

    return (
        <>
            <PromoCodeSendModal
                isOpen={isModalOpen}
                title={"Send Asset via "}
                onClose={() => setIsModalOpen(false)}
                type={sendType}
                onConfirm={async ({
                    type,
                    value,
                    setOpen,
                    setEmail,
                    setPhoneNumber,
                    setType,
                }) => {
                    try {
                        const mutationData = {
                            uid: uid,
                            methodType: "qr_code",
                            email: type === "mail" ? value : undefined,
                            phone_number: type !== "mail" ? value : undefined,
                            id: `${data.id}`,
                            type,
                        };

                        await client.mutate({
                            mutation: TICKET_SEND_EMAIL_SMS,
                            variables: {
                                data: mutationData,
                            },
                        });

                        toast.success("Asset QR Code Sent Successfully");
                        setOpen(false);
                        setEmail("");
                        setPhoneNumber("");
                        setType("");
                    } catch (error: any) {
                        let errorMessage = "Error Sending Asset QR Code";
                        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                            errorMessage += ": " + error.graphQLErrors[0].message;
                        } else if (error.networkError) {
                            errorMessage += ": Network error";
                        } else if (error.message) {
                            errorMessage += ": " + error.message;
                        }

                        toast.error(errorMessage);
                    }
                }}
            />

            <button
                onClick={handleButtonClick}
                className="rounded-md border border-gray-300 bg-gray-400  py-1 px-2 text-sm font-medium shadow-sm text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
                Disassociate Asset
            </button>
            <button
                onClick={handleDownloadClick}
                className="ml-2 rounded-md border border-gray-300 bg-gray-400 py-1 px-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                title="Download QR"
            >
                Download QR
            </button>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    handleSendClick("mail");
                }}
                className="ml-2 rounded-md border border-gray-300 bg-gray-400 py-1 px-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                title="Send via Email"
            >
                Send Email
            </button>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    handleSendClick("sms");
                }}
                className="ml-2 rounded-md border border-gray-300 bg-gray-400 py-1 px-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                title="Send via SMS"
            >
                Send Text
            </button>
        </>
    );
};


type CellRenderer = (params: {
    value: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined;
    data: RFIDAssetsRow;
}) => JSX.Element;

const createCellRenderer = (permission: boolean, linkFunc: (params: {
    data: RFIDAssetsRow
}) => string): CellRenderer => {
    return (params) => (
        <>
            {permission ? (
                <Link to={linkFunc(params)}>
                    <Badge>{params.value}</Badge>
                </Link>
            ) : (
                <Badge>{params.value}</Badge>
            )}
        </>
    );
};

const generateColDefs = (): ColDef<RFIDAssetsRow>[] => [
    {
        headerName: 'UID',
        valueGetter: p => p.data?.uid,
        cellRenderer: createCellRenderer(
            true,
            (p) => `/rfid-assets/${p.data.id}/edit`
        ),
    },
    {
        headerName: 'Type',
        valueGetter: p => p.data?.is_qr,
        valueFormatter: (p) => {
            return p.data?.is_qr ? "QR" : "RFID";
        },
    },
    {
        headerName: "Token Balance",
        valueGetter: (params) => {
            const tokensBalance = params?.data?.tokens_balance;
            if (tokensBalance && Object.keys(tokensBalance).length > 0) {
                const tokenStrings = Object.values<any>(tokensBalance).map(
                    (token) => `${token.redeemable_token_name} - ${token.balance}`
                );
                return tokenStrings.join(", ");
            }
            return null;
        },
        cellRenderer: (params: any) => {
            const tokensBalance = params.value;
            if (tokensBalance) {
                return <div>{tokensBalance}</div>;
            }
            return null;
        },
    },
    {
        headerName: "Is Active?",
        valueGetter: (p) => p.data?.is_active,
        valueFormatter: (p) => {
            return p.data?.is_active ? "Yes" : "No";
        },
    },
    {
        headerName: "Actions",
        cellRenderer: ButtonCellRenderer,
        minWidth: 500,
    }
];

export const rfidColDefs: ColDef<RFIDAssetsRow>[] = generateColDefs();
